// @ts-nocheck
import { Dimmer, Loader } from 'semantic-ui-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import useUserForm from './useUserForm';
import Form from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv8';
import { useDispatch } from 'react-redux';
import { addUser } from '../../../redux/actions/clients';
import { removeDuplicates } from '../../../utils';

const getUISchema = (formSchema) => {
  return Object.keys(formSchema.properties).reduce((acc, curr) => {
    if (formSchema.properties[curr].type === 'boolean') {
      acc[curr] = {
        'ui:options': {
          component: 'select',
          options: {
            label: true,
          },
        },
      };
    }
    return acc;
  }, {});
};

const AddUser = () => {
  const { id } = useParams<{ id: string }>();
  const [clientId, setClientId] = useState(id);
  const { userForm, isLoading, updated } = useUserForm(
    clientId,
    id ? true : false
  );
  const [formData, setFormData] = useState(
    id ? { ClientId: parseInt(id, 10) } : undefined
  );
  const dispatch = useDispatch();
  const handleChange = ({ formData }) => {
    if (!id && formData.ClientId && clientId !== formData.ClientId) {
      setFormData(formData);
      setClientId(formData.ClientId);
    }
  };

  const handleSubmit = ({ formData }) => {
    formData.ManagedProperties = removeDuplicates(formData.ManagedProperties);
    dispatch(addUser(formData));
  };

  return (
    <div>
      {isLoading || !userForm || !updated ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <Form
          validator={validator}
          schema={userForm as any}
          onSubmit={handleSubmit}
          onChange={handleChange}
          uiSchema={getUISchema(userForm)}
          formData={formData}
          noValidate={
            userForm.properties.ManagedProperties?.items?.anyOf?.length > 500
          }
        />
      )}
    </div>
  );
};
export default AddUser;
